(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4960],{

/***/ 71137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/sitemap",
      function () {
        return __webpack_require__(79218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sitemap; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./ui/components/ManagedHeading.tsx
var ManagedHeading = __webpack_require__(93512);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
// EXTERNAL MODULE: ./groq/shared/MainNavItemLink.ts
var MainNavItemLink = __webpack_require__(88035);
// EXTERNAL MODULE: ./utils/removeLeadingSlash.ts
var removeLeadingSlash = __webpack_require__(59087);
;// CONCATENATED MODULE: ./utils/sitemap.ts





var categoryPriorityList = [
    "womens",
    "mens",
    "kids",
    "new-arrivals",
    "collections",
    "collaborations",
    "gift-guide",
    "sale",
    "outlet",
    "exclusion-list",
    "puma", 
];
var ArticlesQuery = "\n  *[_type == 'Article' && defined(puid.current) && !($country in regionalExclusion)] {\n    ".concat((0,LocaleString/* LocaleString */.E)("title"), ',\n    "url": "articles/" + puid.current,\n    availableFrom,\n    availableTo,\n  }\n');
var CategoriesQuery = "\n*[_type == 'category' && country == $country && hasItemsInStock > 0]{\n    id,\n    _id,\n    ".concat((0,LocaleString/* LocaleString */.E)("name"), ',\n    url,\n    online,\n    onlineTo,\n    onlineFrom,\n    "parentCategoryId": parentCategory._ref,\n    "noIndex": seo.noIndex,\n}\n');
var rootCategoryQuery = "\n*[_type == 'category' && country == $country && id == 'root']{\n  _id,\n}[0]._id\n";
var RedirectsQuery = "\n  *[_type == 'UrlRedirect' && country == $country && defined(vanityUrl.current) && (defined(link) || defined(support) || defined(category) || defined(product) || defined(marketing))] {\n    \"vanityUrl\": vanityUrl.current,\n    online,\n    availableFrom,\n    availableTo\n  }\n";
var SupportPagesQuery = "\n*[_type == 'SupportPage' && country == $country && defined(url.current)] {\n  \"url\": url.current,\n  availableFrom,\n  availableTo,\n  ".concat((0,LocaleString/* LocaleString */.E)("title"), ',\n  "noIndex": seo.noIndex\n  }\n  ');
var MarketingPagesQuery = "\n  *[_type == 'MarketingPage' && country == $country && defined(url.current)] {\n    \"url\": url.current,\n    seo {\n      ".concat((0,LocaleString/* LocaleString */.E)("pageTitles"), ",\n      pageTitle,\n      noIndex\n    },\n  }\n");
var MainNavItem = function(field) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return "\n  ".concat(field, " {\n    ").concat((0,MainNavItemLink/* MainNavItemLink */.r)("link"), ",\n    availableOn,\n    ").concat(depth > 0 ? MainNavItem('children[availableOn == "mobileApp"]', depth - 1) : "", "\n  }\n");
};
var MobileMainNavLinksQuery = '\n  *[_type == "MainNav" && country == $country][0] {\n    children[availableOn == "mobileApp"] {\n      '.concat((0,MainNavItemLink/* MainNavItemLink */.r)("link"), ",\n      ").concat(MainNavItem('navChildren[availableOn == "mobileApp"]'), ",\n      ").concat(MainNavItem('children[availableOn == "mobileApp"]', 4), ",\n    }\n  }\n");
var SitemapQuery = '{\n    "articles": '.concat(ArticlesQuery, ',\n    "rootCategory": ').concat(rootCategoryQuery, ',\n    "categories": ').concat(CategoriesQuery, ',\n    "redirects": ').concat(RedirectsQuery, ',\n    "supportPages": ').concat(SupportPagesQuery, ',\n    "marketingPages": ').concat(MarketingPagesQuery, ',\n    "mobileMainNavLinks": ').concat(MobileMainNavLinksQuery, ",\n}");
var sortCategories = function(categories) {
    return categories === null || categories === void 0 ? void 0 : categories.sort(function(a, b) {
        var indexA = categoryPriorityList.indexOf(a.id);
        var indexB = categoryPriorityList.indexOf(b.id);
        if (indexA === -1 && indexB === -1) {
            return 0;
        } else if (indexA === -1) {
            return 1;
        } else if (indexB === -1) {
            return -1;
        } else {
            return indexA - indexB;
        }
    });
};
var buildCategoryTree = function(categories, parentId) {
    var result = [];
    categories.filter(function(category) {
        return category.parentCategoryId === parentId;
    }).forEach(function(category) {
        var subcategories = buildCategoryTree(categories, category._id);
        if (category.url || subcategories.some(function(subcategory) {
            return subcategory.url;
        })) {
            result.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
                categories: subcategories
            }));
        }
    });
    return result;
};
var getNameFromUrl = function(url) {
    if (!url) {
        return "";
    }
    var urlParts = url.split("/");
    var transformedParts = urlParts.map(function(part) {
        return part.split("-").map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(" ");
    });
    return transformedParts.join(" ");
};
var getNavLinksFlatArray = function(navItems) {
    var flatArray = [];
    var flatten = function(items) {
        items.forEach(function(item) {
            var ref;
            if ((ref = item.link) === null || ref === void 0 ? void 0 : ref.href) {
                flatArray.push((0,removeLeadingSlash/* removeLeadingSlash */.F)(item.link.href));
            }
            if (item.children) {
                flatten(item.children);
            }
            if (item.navChildren) {
                flatten(item.navChildren);
            }
        });
    };
    flatten(navItems);
    return flatArray;
};

// EXTERNAL MODULE: ./utils/isContentOnline.ts
var isContentOnline = __webpack_require__(89996);
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
;// CONCATENATED MODULE: ./pages/[country]/[language]/sitemap.tsx














var useSitemapQuery = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "Sitemap",
        query: SitemapQuery
    }), 1), sitemap = ref1[0];
    var siteConfig = (0,useSiteConfig/* useSiteConfig */.N)();
    var filteredSitemap = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        var mainNavMobileLinks = getNavLinksFlatArray((sitemap === null || sitemap === void 0 ? void 0 : (ref = sitemap.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.mobileMainNavLinks) === null || ref2 === void 0 ? void 0 : ref2.children) || []);
        var categories = sitemap === null || sitemap === void 0 ? void 0 : (ref3 = sitemap.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.categories;
        var preview = (0,useGroqQuery/* groqPreviewInput */.i8)(router.query);
        var redirectsUrls = (sitemap === null || sitemap === void 0 ? void 0 : (ref5 = sitemap.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.redirects) === null || ref7 === void 0 ? void 0 : ref7.filter(function(redirect) {
            return (0,isContentOnline/* isContentOnline */.e)({
                online: redirect.online,
                onlineFrom: redirect.availableFrom,
                onlineTo: redirect.availableTo
            }, preview);
        }).map(function(redirect) {
            return redirect.vanityUrl;
        })) || [];
        var rootCategory = sitemap === null || sitemap === void 0 ? void 0 : (ref8 = sitemap.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.content) === null || ref9 === void 0 ? void 0 : ref9.rootCategory;
        var filteredCategories = sortCategories(categories === null || categories === void 0 ? void 0 : categories.filter(function(category) {
            if (redirectsUrls.includes((0,removeLeadingSlash/* removeLeadingSlash */.F)(category.url)) || mainNavMobileLinks.includes((0,removeLeadingSlash/* removeLeadingSlash */.F)(category.url))) {
                category.url = "";
                return true;
            }
            return !category.noIndex && (0,isContentOnline/* isContentOnline */.e)(category, preview);
        })) || [];
        var categoryTree = buildCategoryTree(filteredCategories || [], rootCategory);
        return {
            articles: (sitemap === null || sitemap === void 0 ? void 0 : (ref10 = sitemap.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.content) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.articles) === null || ref12 === void 0 ? void 0 : ref12.filter(function(article) {
                return (0,isContentOnline/* isContentOnline */.e)({
                    onlineFrom: article.availableFrom,
                    onlineTo: article.availableTo
                }, preview) && !redirectsUrls.includes((0,removeLeadingSlash/* removeLeadingSlash */.F)(article.url));
            })) || [],
            categories: categoryTree,
            supportPages: (sitemap === null || sitemap === void 0 ? void 0 : (ref13 = sitemap.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.content) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.supportPages) === null || ref15 === void 0 ? void 0 : ref15.filter(function(supportPage) {
                return !supportPage.noIndex && (0,isContentOnline/* isContentOnline */.e)({
                    onlineFrom: supportPage.availableFrom,
                    onlineTo: supportPage.availableTo
                }, preview) && !redirectsUrls.includes((0,removeLeadingSlash/* removeLeadingSlash */.F)(supportPage.url));
            })) || [],
            marketingPages: (sitemap === null || sitemap === void 0 ? void 0 : (ref16 = sitemap.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.content) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.marketingPages) === null || ref18 === void 0 ? void 0 : ref18.filter(function(marketingPage) {
                var ref;
                return !(marketingPage === null || marketingPage === void 0 ? void 0 : (ref = marketingPage.seo) === null || ref === void 0 ? void 0 : ref.noIndex) && !redirectsUrls.includes((0,removeLeadingSlash/* removeLeadingSlash */.F)(marketingPage.url));
            })) || [],
            returnsPage: !(siteConfig === null || siteConfig === void 0 ? void 0 : (ref19 = siteConfig.staticFeatures) === null || ref19 === void 0 ? void 0 : ref19.returnsPageDisabled) && !redirectsUrls.includes("returns") && {
                url: "/returns",
                title: "Returns"
            }
        };
    }, [
        sitemap,
        router.query,
        siteConfig === null || siteConfig === void 0 ? void 0 : (ref = siteConfig.staticFeatures) === null || ref === void 0 ? void 0 : ref.returnsPageDisabled
    ]);
    return filteredSitemap;
};
var headingElements = {
    h2: {
        tag: "h2",
        className: "col-span-2 md:col-span-1 text-2xl md:text-5xl font-bold break-all"
    },
    h3: {
        tag: "h3",
        className: "text-base text-neutral-70 font-normal mb-2 md:mb-1"
    },
    h4: {
        tag: "h4",
        className: "text-base text-neutral-70 font-normal mb-2 md:mb-1"
    },
    h5: {
        tag: "h5",
        className: "text-base text-neutral-70 font-normal mb-2 md:mb-1"
    },
    h6: {
        tag: "h6",
        className: "text-base text-neutral-70 font-normal mb-2 md:mb-1"
    }
};
var renderHeading = function(heading, url, title) {
    var ref;
    return !!heading && /*#__PURE__*/ react.createElement(heading, {
        className: ((ref = headingElements[heading || "h6"]) === null || ref === void 0 ? void 0 : ref.className) || ""
    }, url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: url,
        children: title
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: title
    }));
};
var renderCategories = function(categories, host, locale) {
    var nest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!(categories === null || categories === void 0 ? void 0 : categories.length)) {
        return null;
    }
    var leafCategories = categories === null || categories === void 0 ? void 0 : categories.filter(function(category) {
        var ref;
        return !(category === null || category === void 0 ? void 0 : (ref = category.categories) === null || ref === void 0 ? void 0 : ref.length);
    });
    var parentCategories = categories === null || categories === void 0 ? void 0 : categories.filter(function(category) {
        var ref;
        return category === null || category === void 0 ? void 0 : (ref = category.categories) === null || ref === void 0 ? void 0 : ref.length;
    });
    var headingLevel = "h".concat(nest + 2);
    if (nest === 0) {
        return parentCategories === null || parentCategories === void 0 ? void 0 : parentCategories.map(function(category, index) {
            var ref;
            return category.name && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full bg-black h-0.5 my-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 2xs:grid-cols-2 md:grid-cols-3 gap-6",
                        children: [
                            renderHeading("h2", category.url ? "".concat(host, "/").concat(locale, "/").concat((0,removeLeadingSlash/* removeLeadingSlash */.F)(category.url), " ") : "", category.name),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "2xs:col-span-2 2xs:column-count-2 gap-4 md:gap-6",
                                children: (category === null || category === void 0 ? void 0 : (ref = category.categories) === null || ref === void 0 ? void 0 : ref.length) > 0 && renderCategories(category.categories, host, locale, nest + 1)
                            })
                        ]
                    })
                ]
            }, index);
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: leafCategories === null || leafCategories === void 0 ? void 0 : leafCategories.map(function(category, index) {
                    return category.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "text-base text-neutral-70 font-normal mb-2 md:mb-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: category.url ? "".concat(host, "/").concat(locale, "/").concat((0,removeLeadingSlash/* removeLeadingSlash */.F)(category.url), " ") : "",
                            children: category.name ? category.name : getNameFromUrl(category.url)
                        })
                    }, index);
                })
            }),
            parentCategories === null || parentCategories === void 0 ? void 0 : parentCategories.map(function(category, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        renderHeading(headingLevel, category.url ? "".concat(host, "/").concat(locale, "/").concat((0,removeLeadingSlash/* removeLeadingSlash */.F)(category.url), " ") : "", category.name || getNameFromUrl(category.url)),
                        (category === null || category === void 0 ? void 0 : (ref = category.categories) === null || ref === void 0 ? void 0 : ref.length) > 0 && renderCategories(category.categories, host, locale, nest + 1)
                    ]
                }, index);
            })
        ]
    });
};
var renderList = function(heading, url, items, host, locale) {
    if (!items || items.length < 1) {
        return;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full bg-black h-0.5 my-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 2xs:grid-cols-2 md:grid-cols-3 gap-6",
                children: [
                    renderHeading("h2", url ? "".concat(host, "/").concat(locale, "/").concat((0,removeLeadingSlash/* removeLeadingSlash */.F)(url)) : "", heading || getNameFromUrl(url)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "2xs:col-span-2 2xs:column-count-2 gap-4 md:gap-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                                return (0,isNotNullish/* isNotNullish */.l)(item.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "text-base text-neutral-70 font-normal mb-2 md:mb-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "".concat(host, "/").concat(locale, "/").concat((0,removeLeadingSlash/* removeLeadingSlash */.F)(item.url)),
                                        children: item.title && typeof item.title === "string" ? item.title : "".concat(getNameFromUrl(item.url))
                                    })
                                }, index);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var Sitemap = function() {
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), countryCode = ref.country, language = ref.language, host = ref.host;
    var ref1 = useSitemapQuery(), categories = ref1.categories, articles = ref1.articles, supportPages = ref1.supportPages, marketingPages = ref1.marketingPages, returnsPage = ref1.returnsPage;
    var mappedCountryCode = (0,utils_locale/* getMappedCountryCode */.p5)(countryCode) || countryCode.toLowerCase();
    var locale = "".concat(mappedCountryCode, "/").concat(language);
    var hostUrl = host.startsWith("localhost") ? "http://".concat(host) : "https://".concat(host);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: "Sitemap | Puma"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-6xl mx-auto px-4 md:px-8 lg:px-16 mt-16 mb-2 md:mb-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                        tag: "h1",
                        className: "text-5xl md:text-7xl font-bold pb-4",
                        children: "SITEMAP"
                    }),
                    renderCategories(categories, hostUrl, locale),
                    renderList("Articles", "articles", articles, hostUrl, locale),
                    renderList("Marketing", "", marketingPages, hostUrl, locale),
                    renderList("Support", "", (0,_to_consumable_array/* default */.Z)(supportPages).concat([
                        returnsPage
                    ]), hostUrl, locale)
                ]
            })
        ]
    });
};
/* harmony default export */ var sitemap = (Sitemap);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9294,9774,2888,179], function() { return __webpack_exec__(71137); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);